import React/*, { useEffect, useState }*/ from "react";
import Icon from "./../../assets/img/chat_icon.png";
import "./ChatButton.css";

const CHAT_FORM_URL = '/chat';

function ChatButton(){

  return (
    <div className="floating-chat">
      <a href={CHAT_FORM_URL}>
        <img src={Icon} alt="chat icon" /> <span>Chat</span>
      </a>
    </div>
  );
};

export default ChatButton;
